"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WsAiHubDashboardListView = void 0;
var react_1 = __importStar(require("react"));
var office_ui_fabric_react_1 = require("office-ui-fabric-react");
var MessageBar_1 = require("office-ui-fabric-react/lib/MessageBar");
var react_router_dom_1 = require("react-router-dom");
var list_view_utils_1 = require("./utils/list-view-utils");
require("./styles/list-view.scss");
var ALL_FILTER_KEY = '';
var LIST_VIEW_COLUMNS = [
    {
        key: 'name',
        title: 'AI Use Case',
    },
    {
        key: 'complexity',
        title: 'Complexity',
    },
    {
        key: 'priority',
        title: 'Priority',
    },
    {
        key: 'owner',
        title: 'Owner',
    },
    {
        key: 'stage',
        title: 'Stage',
    },
    {
        key: 'sourceSystem',
        title: 'Source System',
    },
    {
        key: 'clientGroup',
        title: 'Client Group',
    },
    {
        key: 'businessFunction',
        title: 'Business Function',
    },
];
var DEFAULT_FILTERS = {
    stage: '',
    sourceSystem: '',
    owner: '',
};
var getSortIndicator = function (sortKey, activeSortKey, sortDirection) {
    if (sortKey !== activeSortKey) {
        return null;
    }
    return sortDirection === 'asc' ? '↑' : '↓';
};
var renderCellValue = function (columnKey, value, matcher) {
    var badgeTone = list_view_utils_1.getListCellBadgeTone(columnKey, value);
    var content = renderHighlightedText(value, matcher);
    if (!badgeTone) {
        return content;
    }
    return react_1.default.createElement("span", { className: "ws-ai-hub-badge ws-ai-hub-badge-" + badgeTone }, content);
};
var renderHighlightedText = function (value, matcher) {
    if (!matcher) {
        return value;
    }
    var textParts = value.split(matcher.splitter);
    return textParts.map(function (textPart, index) {
        if (matcher.normalizedTerms[textPart.toLowerCase()]) {
            return (react_1.default.createElement("span", { key: "search-match-" + textPart + "-" + index, className: "ws-ai-hub-dashboard-list-search-highlight" }, textPart));
        }
        return react_1.default.createElement(react_1.default.Fragment, { key: "search-text-" + textPart + "-" + index }, textPart);
    });
};
var buildFilterDropdownOptions = function (values, counts, allLabel) {
    return __spreadArrays([
        { key: ALL_FILTER_KEY, text: allLabel + " (" + counts.all + ")" }
    ], values.map(function (value) { return ({
        key: value,
        text: value + " (" + (counts.byValue[value] || 0) + ")",
    }); }));
};
var copyEmailAddress = function (emailAddress) { return __awaiter(void 0, void 0, void 0, function () {
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                if (!emailAddress || emailAddress === '-') {
                    return [2 /*return*/];
                }
                if (!((_a = navigator.clipboard) === null || _a === void 0 ? void 0 : _a.writeText)) return [3 /*break*/, 2];
                return [4 /*yield*/, navigator.clipboard.writeText(emailAddress)];
            case 1:
                _b.sent();
                _b.label = 2;
            case 2: return [2 /*return*/];
        }
    });
}); };
/**
 * List-focused dashboard view showing basic use-case metadata.
 *
 * @param {WsAiHubDashboardListViewProps} props - Component props
 * @returns {JSX.Element} Rendered component
 */
var WsAiHubDashboardListView = function (props) {
    var _a = react_1.useState(DEFAULT_FILTERS), filters = _a[0], setFilters = _a[1];
    var _b = react_1.useState(''), searchText = _b[0], setSearchText = _b[1];
    var _c = react_1.useState('id'), sortKey = _c[0], setSortKey = _c[1];
    var _d = react_1.useState('desc'), sortDirection = _d[0], setSortDirection = _d[1];
    var rows = react_1.useMemo(function () { return list_view_utils_1.buildListViewRows(props.useCases); }, [props.useCases]);
    // Precompute search matcher once per search-text change so highlight rendering
    // does not rebuild the regex / normalized term set for every cell.
    var searchMatcher = react_1.useMemo(function () { return list_view_utils_1.buildListSearchMatcher(searchText); }, [searchText]);
    // Pre-aggregate counts per filter dimension in a single pass over the rows,
    // instead of re-scanning rows once per dropdown option.
    var stageValues = react_1.useMemo(function () { return list_view_utils_1.getListFilterValues(rows, 'stage'); }, [rows]);
    var sourceValues = react_1.useMemo(function () { return list_view_utils_1.getListFilterValues(rows, 'sourceSystem'); }, [rows]);
    var ownerValues = react_1.useMemo(function () { return list_view_utils_1.getListFilterValues(rows, 'owner'); }, [rows]);
    var stageCounts = react_1.useMemo(function () { return list_view_utils_1.getListFilterResultCounts(rows, filters, 'stage', searchText); }, [filters, rows, searchText]);
    var sourceCounts = react_1.useMemo(function () { return list_view_utils_1.getListFilterResultCounts(rows, filters, 'sourceSystem', searchText); }, [filters, rows, searchText]);
    var ownerCounts = react_1.useMemo(function () { return list_view_utils_1.getListFilterResultCounts(rows, filters, 'owner', searchText); }, [filters, rows, searchText]);
    var stageOptions = react_1.useMemo(function () { return buildFilterDropdownOptions(stageValues, stageCounts, 'All stages'); }, [stageValues, stageCounts]);
    var sourceOptions = react_1.useMemo(function () { return buildFilterDropdownOptions(sourceValues, sourceCounts, 'All sources'); }, [sourceValues, sourceCounts]);
    var ownerOptions = react_1.useMemo(function () { return buildFilterDropdownOptions(ownerValues, ownerCounts, 'All owners'); }, [ownerValues, ownerCounts]);
    var visibleRows = react_1.useMemo(function () {
        return list_view_utils_1.filterAndSortListRows(rows, filters, searchText, sortKey, sortDirection);
    }, [filters, rows, searchText, sortDirection, sortKey]);
    var handleSort = function (nextSortKey) {
        if (sortKey === nextSortKey) {
            setSortDirection(function (currentDirection) {
                return currentDirection === 'asc' ? 'desc' : 'asc';
            });
            return;
        }
        setSortKey(nextSortKey);
        setSortDirection('asc');
    };
    var handleFilterChange = function (filterKey, option) {
        setFilters(function (currentFilters) {
            var _a;
            return (__assign(__assign({}, currentFilters), (_a = {}, _a[filterKey] = "" + ((option === null || option === void 0 ? void 0 : option.key) || ''), _a)));
        });
    };
    var hasActiveFilters = searchText !== '' ||
        filters.stage !== '' ||
        filters.sourceSystem !== '' ||
        filters.owner !== '';
    var handleResetFilters = function () {
        setSearchText('');
        setFilters(DEFAULT_FILTERS);
    };
    return (react_1.default.createElement("div", { className: "ws-ai-hub-dashboard-list-view" },
        react_1.default.createElement("div", { className: "ws-ai-hub-dashboard-list-controls" },
            react_1.default.createElement("div", { className: "ws-ai-hub-dashboard-list-filter ws-ai-hub-dashboard-list-search-filter" },
                react_1.default.createElement(office_ui_fabric_react_1.Label, { className: "ws-ai-hub-dashboard-list-search-label" }, "Search"),
                react_1.default.createElement(office_ui_fabric_react_1.SearchBox, { value: searchText, placeholder: "Search across all columns", disableAnimation: true, onChange: function (event, nextValue) {
                        setSearchText(nextValue || '');
                    }, onClear: function () {
                        setSearchText('');
                    } })),
            react_1.default.createElement("div", { className: "ws-ai-hub-dashboard-list-controls-separator", "aria-hidden": "true" }),
            react_1.default.createElement("div", { className: "ws-ai-hub-dashboard-list-filter" },
                react_1.default.createElement(office_ui_fabric_react_1.Dropdown, { label: "Stage", selectedKey: filters.stage, options: stageOptions, onChange: function (event, option) {
                        handleFilterChange('stage', option);
                    } })),
            react_1.default.createElement("div", { className: "ws-ai-hub-dashboard-list-filter" },
                react_1.default.createElement(office_ui_fabric_react_1.Dropdown, { label: "Source", selectedKey: filters.sourceSystem, options: sourceOptions, onChange: function (event, option) {
                        handleFilterChange('sourceSystem', option);
                    } })),
            react_1.default.createElement("div", { className: "ws-ai-hub-dashboard-list-filter" },
                react_1.default.createElement(office_ui_fabric_react_1.Dropdown, { label: "Owner", selectedKey: filters.owner, options: ownerOptions, onChange: function (event, option) {
                        handleFilterChange('owner', option);
                    } })),
            react_1.default.createElement("div", { className: "ws-ai-hub-dashboard-list-reset" },
                react_1.default.createElement(office_ui_fabric_react_1.IconButton, { iconProps: { iconName: 'Undo' }, title: "Reset filters", ariaLabel: "Reset filters", className: "ws-admin-button-neutral-icon ws-ai-hub-dashboard-list-reset-button", disabled: !hasActiveFilters, onClick: handleResetFilters }))),
        react_1.default.createElement("div", { className: "ws-ai-hub-dashboard-list-table-wrap" },
            react_1.default.createElement("table", { className: "table is-hoverable is-fullwidth ws-ai-hub-list-table ws-ai-hub-dashboard-list-table" },
                react_1.default.createElement("colgroup", null,
                    react_1.default.createElement("col", { className: "ws-ai-hub-dashboard-list-column ws-ai-hub-dashboard-list-column-name" }),
                    react_1.default.createElement("col", { className: "ws-ai-hub-dashboard-list-column ws-ai-hub-dashboard-list-column-complexity" }),
                    react_1.default.createElement("col", { className: "ws-ai-hub-dashboard-list-column ws-ai-hub-dashboard-list-column-priority" }),
                    react_1.default.createElement("col", { className: "ws-ai-hub-dashboard-list-column ws-ai-hub-dashboard-list-column-owner" }),
                    react_1.default.createElement("col", { className: "ws-ai-hub-dashboard-list-column ws-ai-hub-dashboard-list-column-stage" }),
                    react_1.default.createElement("col", { className: "ws-ai-hub-dashboard-list-column ws-ai-hub-dashboard-list-column-sourceSystem" }),
                    react_1.default.createElement("col", { className: "ws-ai-hub-dashboard-list-column ws-ai-hub-dashboard-list-column-clientGroup" }),
                    react_1.default.createElement("col", { className: "ws-ai-hub-dashboard-list-column ws-ai-hub-dashboard-list-column-businessFunction" })),
                react_1.default.createElement("thead", null,
                    react_1.default.createElement("tr", null, LIST_VIEW_COLUMNS.map(function (column) {
                        var sortIndicator = getSortIndicator(column.key, sortKey, sortDirection);
                        return (react_1.default.createElement("th", { key: column.key, className: "ws-ai-hub-dashboard-list-head ws-ai-hub-dashboard-list-head-" + column.key },
                            react_1.default.createElement("button", { type: "button", className: "ws-ai-hub-dashboard-list-sort-button ws-ai-hub-dashboard-list-sort-button-" + column.key, onClick: function () { return handleSort(column.key); }, "aria-label": "Sort by " + column.title },
                                react_1.default.createElement("span", null, column.title),
                                sortIndicator && (react_1.default.createElement("span", { className: "ws-ai-hub-dashboard-list-sort-indicator" }, sortIndicator)))));
                    }))),
                react_1.default.createElement("tbody", null, visibleRows.length > 0 ? (visibleRows.map(function (row) {
                    var ownerEmailTitle = row.ownerEmail && row.ownerEmail !== '-'
                        ? "Copy " + row.ownerEmail
                        : 'Owner email not available';
                    return (react_1.default.createElement("tr", { key: "ws-ai-hub-use-case-" + row.id },
                        react_1.default.createElement("td", { className: "ws-ai-hub-dashboard-list-cell ws-ai-hub-dashboard-list-cell-name" },
                            react_1.default.createElement(react_router_dom_1.NavLink, { className: "ws-ai-hub-dashboard-list-name-link", to: "/deliver/ai/use-cases/" + row.id, title: row.id + " " + row.name },
                                react_1.default.createElement("span", { className: "ws-ai-hub-dashboard-list-name-id", title: "Use case ID " + row.id }, renderHighlightedText(row.id, searchMatcher)),
                                react_1.default.createElement("span", { className: "ws-ai-hub-dashboard-list-name-text" }, renderHighlightedText(row.name, searchMatcher)))),
                        react_1.default.createElement("td", { className: "ws-ai-hub-dashboard-list-cell ws-ai-hub-dashboard-list-cell-complexity" }, renderCellValue('complexity', row.complexity, searchMatcher)),
                        react_1.default.createElement("td", { className: "ws-ai-hub-dashboard-list-cell ws-ai-hub-dashboard-list-cell-priority" }, renderCellValue('priority', row.priority, searchMatcher)),
                        react_1.default.createElement("td", { className: "ws-ai-hub-dashboard-list-cell ws-ai-hub-dashboard-list-cell-owner" },
                            react_1.default.createElement("div", { className: "ws-ai-hub-dashboard-list-owner-content" },
                                react_1.default.createElement("span", { className: "ws-ai-hub-dashboard-list-owner-name", title: row.owner }, renderHighlightedText(row.owner, searchMatcher)),
                                react_1.default.createElement(office_ui_fabric_react_1.IconButton, { className: "ws-ai-hub-dashboard-list-owner-copy-button", iconProps: { iconName: 'Copy' }, ariaLabel: ownerEmailTitle, title: ownerEmailTitle, disabled: !row.ownerEmail || row.ownerEmail === '-', onClick: function () {
                                        copyEmailAddress(row.ownerEmail).catch(function () { return undefined; });
                                    } }))),
                        react_1.default.createElement("td", { className: "ws-ai-hub-dashboard-list-cell ws-ai-hub-dashboard-list-cell-stage" }, renderCellValue('stage', row.stage, searchMatcher)),
                        react_1.default.createElement("td", { className: "ws-ai-hub-dashboard-list-cell ws-ai-hub-dashboard-list-cell-sourceSystem" }, renderCellValue('sourceSystem', row.sourceSystem, searchMatcher)),
                        react_1.default.createElement("td", { className: "ws-ai-hub-dashboard-list-cell ws-ai-hub-dashboard-list-cell-clientGroup" }, renderCellValue('clientGroup', row.clientGroup, searchMatcher)),
                        react_1.default.createElement("td", { className: "ws-ai-hub-dashboard-list-cell ws-ai-hub-dashboard-list-cell-businessFunction" }, renderCellValue('businessFunction', row.businessFunction, searchMatcher))));
                })) : (react_1.default.createElement("tr", null,
                    react_1.default.createElement("td", { colSpan: LIST_VIEW_COLUMNS.length, className: "ws-ai-hub-dashboard-list-empty" },
                        react_1.default.createElement(MessageBar_1.MessageBar, { messageBarType: MessageBar_1.MessageBarType.info }, searchText.trim()
                            ? "No use cases match the current filters and search for \"" + searchText + "\"."
                            : 'No use cases match the current filters.')))))))));
};
exports.WsAiHubDashboardListView = WsAiHubDashboardListView;
